export default __webpack_public_path__ + "static/screen-assessment-7f19cef33f6121041f144bd34c9cfe26.png";